import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import { Field, FieldArray } from 'formik'
import get from 'lodash/get'

import Input from '../Input'
import RepeatableAction from '../RepeatableAction'
import Tooltip from '@components/Tooltip/Tooltip'
import TextArea from '@components/Form/TextArea'

const SegmentFields = ({
  form,
  name,
  labelName,
  labelNumberOfExpert,
  labelExpertBrief,
  inputProps,
  defaultExpertBrief,
  defaultScreeningQuestion
}) => {
  const segments = get(form.values, name)

  return (
    <div>
      <FieldArray
        name={name}
        render={arrayHelpers => (
          <div className='expert-form__repeatable-input-wrapper'>
            {segments.map((segment, index) => (
              <div
                className='expert-form__repeatable-input expert-form__repeatable-input--segments'
                key={index}
              >
                <Field
                  name={`${name}[${index}].name`}
                  component={Input}
                  label={labelName}
                  {...inputProps}
                />
                <Field
                  name={`${name}[${index}].numberOfExpert`}
                  component={Input}
                  label={labelNumberOfExpert}
                  {...inputProps}
                />
                <Field
                  name={`${name}[${index}].expertBrief`}
                  label={
                    <span>
                      {labelExpertBrief}
                      <Tooltip tooltip='This part will be disclosed to the experts when inviting them to participate in the project.' />
                    </span>
                  }
                  placeholder='e.g. The client is looking to better understand XYZ market and would like to talk to sales professionals.'
                  component={TextArea}
                  {...inputProps}
                />
                <div>
                  <RepeatableAction
                    fieldValues={segments}
                    arrayHelpers={arrayHelpers}
                    index={index}
                    initialObject={{
                      name: '',
                      numberOfExpert: '',
                      expertBrief: defaultExpertBrief,
                      screeningQuestions: [
                        {
                          question: defaultScreeningQuestion
                        }
                      ]
                    }}
                  />
                </div>
              </div>
            ))}
          </div>
        )}
      />
      {form.errors.segmentNameNotRepeating ? (
        <div className='expert-form__input-error'>
          {form.errors.segmentNameNotRepeating}
        </div>
      ) : null}
    </div>
  )
}

SegmentFields.propTypes = {
  form: PropTypes.object,
  name: PropTypes.string,
  labelName: PropTypes.string,
  labelNumberOfExpert: PropTypes.string,
  labelExpertBrief: PropTypes.string,
  inputProps: PropTypes.object,
  defaultExpertBrief: PropTypes.string,
  defaultScreeningQuestion: PropTypes.string
}

export default observer(SegmentFields)
